export const LOCALES = [
  {
    name: "Ukraine",
    shortName: "Укр",
    nativeName: "Українська",
    code: "ua",
    languageCode: "ua",
    isDefault: true,
    value: "",
  },
  {
    name: "English",
    shortName: "Eng",
    nativeName: "English",
    code: "en",
    languageCode: "en",
    isDefault: false,
    value: "",
  },
];
